<era-pane>
  <h5 class="small-caps"
      i18n>Maximum Resident Users</h5>
  <form [formGroup]="maximumResidentUsersForm"
        (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label class="form-label"
             for="maximumResidentUsers">Set the Maximum Resident Users</label>
      <input id="maximumResidentUsers"
             formControlName="maximumResidentUsers"
             required="true"
             class="form-control" />
      <small class="form-text text-muted">Sets the maximum number of users that can use a Shared iPad. This can be set
        only when the iPad is in the
        AwaitingConfiguration phase, before the DeviceConfigured message has been sent to the device. If
        MaximumResidentUsers is greater than the maximum possible number of users supported on the device, the device is
        configured with the maximum possible number of users instead.</small>
    </div>
    <button class="btn btn-primary"
            type="submit"
            [disabled]="!maximumResidentUsersForm.valid">Submit</button>
  </form>
</era-pane>